
/**
 * Some sets of CSS classes for a CRibbon component
 */
export enum RibbonStyles {
  default = 'text-h2 color-text-white text-700 blue-gradient',
  eligible = 'text-big color-text-base green-gradient'
}
